import axios from "axios";
import {getV1URL} from "./API";

export function fetchExhibitionByID(id) {
    return axios.get(getV1URL("exhibition/get"), {
        params: {
            "id": id,
        }
    }).then(res => {
        return res
    })
}

export function postExhibition(exhibition, token) {
    return axios.post(getV1URL("exhibition/create"), exhibition, {
        headers: {
            "Authorization": token,
        }
    })
}

export function editExhibition(token, exhibiton) {
  console.log("post edit model", exhibiton)
  return axios.put(getV1URL("exhibition/edit"), exhibiton, {
    headers: {
      "Authorization": token,
    }
  });
}

export function fetchExhibitions(token, page, query) {
    const limit = 5;
    const offset = (page - 1) * limit;
    return axios.get(getV1URL("exhibition/list"), {
        headers: {
            "Authorization": token,
            "Content-Type": "multipart/form-data",
        },
        params: {
            "offset": offset,
            "limit": limit,
            "query": query,
        }
    })
}

export function deleteExhibition(token, id) {
    return axios.delete(getV1URL("exhibition/delete"), {
        headers: {
            "Authorization": token,
        },
        params: {
            "id": id,
        }
    })
}
